// CatNailPreferences.jsx
import React from 'react';

const CatNailPreferences = ({ groomingBookingData, setGroomingBookingData }) => {
  // Included list tailored for cats
  var included = [
    'Nail Trim & Gentle File',
    'Paw Pad Tidy',
    'Brush Out',
    'Paw Balm'
  ];

  return (
    <div className="nail-preferences">
      <h3>What’s included for cats?</h3>
      <ul>
        {included.map(function(item, i){ return <li key={i}>{item}</li>; })}
      </ul>
    </div>
  );
};

export default CatNailPreferences;
